import BftButton from "common/components/button";
import BftInput from "common/components/input";
import { useState } from "react";
import { Modal } from "react-bootstrap";

const AggiungiTitolareModal = ({
	show,
	onClose,
}: {
	show: boolean;
	onClose: any;
}) => {
	const [titolareData, setTitolareData] = useState({
		nome: "",
		cognome: "",
		idEsponente: "0",
		codiceFiscale: "",
		idFE: String(Math.ceil(Math.random() * 100000)),
		fulfilled: false,
		invitationRequest: false,
		rejected: false,
	});

	const handleChange = (name: string) => (event: any) => {
		setTitolareData({ ...titolareData, [name]: event.target.value });
	};

	const handleSubmit = () => {
		onClose(titolareData);
		setTitolareData({
			nome: "",
			cognome: "",
			idEsponente: "0",
			codiceFiscale: "",
			idFE: String(Math.ceil(Math.random() * 100000)),
			fulfilled: false,
			invitationRequest: false,
			rejected: false,
		});
	};

	return (
		<>
			<Modal show={show} backdrop="static" onHide={onClose} keyboard={false}>
				<Modal.Header closeButton>
					<Modal.Title>Aggiungi nuovo titolare</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<BftInput
						required
						className="mt-3"
						type={"text"}
						name={"nome"}
						value={titolareData.nome}
						placeholder={"Nome*"}
						onChange={handleChange("nome")}
					/>
					<BftInput
						required
						type={"text"}
						name={"cognome"}
						value={titolareData.cognome}
						placeholder={"Cognome*"}
						onChange={handleChange("cognome")}
					/>
				</Modal.Body>
				<Modal.Footer className="justify-content-center">
					<BftButton
						className="btn-buffetti col-12 ml-auto"
						onClick={() => handleSubmit()}
						isDisabled={
							titolareData.nome.length === 0 ||
							titolareData.cognome.length === 0
						}
					>
						Aggiungi
					</BftButton>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default AggiungiTitolareModal;
